import React from "react";
// import { InputText } from "primereact/inputtext";
// import { RadioButton } from "primereact/radiobutton";
// import { Button } from "primereact/button";
// import { useFormik } from "formik";
// import classNames from "classnames";
// import { InputTextarea } from "primereact/inputtextarea";
// import { Checkbox } from "primereact/checkbox";
// // import { handleGetRequest } from "../../../services/GetTemplate";
// // import { handlePostRequest } from "../../../services/PostTemplate";
// // import { handlePutRequest } from "../../../services/PutTemplate";
// import { useDispatch, useSelector } from "react-redux";
// // import { SetEditCompanyAccountFlagAction, SetCompanyAccountFormDataToNullAction, GetCompanyAccountDetailsAction } from "../../../redux/actions/companyAction";
// import * as Yup from "yup";
// import { stubString } from "lodash";

function AddEditApproveBankBranchManagement({ type }) {
    // const [loading, setloading] = useState(false);
    // const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    // const [bankOptions, setbankOptions] = useState([]);
    // const [branchOptions, setbranchOptions] = useState([]);

    // const dispatch = useDispatch();
    // console.log("type of operation to done", type);

    // // const editFlag__Store = useSelector((state) => state.companySlice?.companyAccountEditFlag);
    // // const formData__Store = useSelector((state) => state.companySlice?.companyAccountFormData);

    // // useEffect(() => {
    // //     if (editFlag__Store) {
    // //         fillCompanyAccountForm();
    // //     }
    // // }, [editFlag__Store, formData__Store]); // eslint-disable-line

    // // useEffect(() => {
    // //     handleGetRequest("/zbiz/lov/lovBank").then((res) => {
    // //         setbankOptions(res?.data);
    // //     });
    // // }, []);

    // // useEffect(() => {
    // //     handleGetRequest("/zbiz/lov/lovBranch").then((res) => {
    // //         setbranchOptions(res?.data);
    // //     });
    // // }, []);

    // const handleCancel = (e) => {
    //     e.preventDefault();
    //     formik.resetForm();
    // };
    // // const getCompanyAccountDetail = async () => {
    // //     await dispatch(GetCompanyAccountDetailsAction("zbiz/nonFin/getAccounts/" + companyId));
    // // };

    // // const fillCompanyAccountForm = () => {
    // //     formik.setFieldValue("bankId", formData__Store?.bankId?.toString());
    // //     formik.setFieldValue("bankName", formData__Store?.bankName?.toString());
    // //     formik.setFieldValue("isPrincipal", formData__Store?.isPrincipal?.toString());
    // // };

    // const validationSchema = Yup.object().shape({
    //     selectBankType: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
    //     selectBank: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
    //     branchCode: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
    //     branchName: Yup.string()
    //         .required("This field is required.")
    //         .matches(/^[A-Za-z0-9 ]+$/, "Special Character are not allowed")
    //         .max(20, "Maximum length 20 allowed"),
    //     description: Yup.string().required("This field is required."),
    //     branchAddress: Yup.string().required("This field is required."),
    //     branchContactNo: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
    //     selectCountry: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
    //     selectProvince: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
    //     selectCity: Yup.string().required("This field is required.").max(100, "Maximum length 100 allowed"),
    // });

    // const formik = useFormik({
    //     validationSchema: validationSchema,
    //     initialValues: {
    //         selectBankType: "",
    //         selectBank: "",
    //         branchCode: "",
    //         branchName: "",
    //         description: "",
    //         branchAddress: "",
    //         branchContactNo: "",
    //         selectCountry: "",
    //         selectProvince: "",
    //         selectCity: "",
    //         isPrintingLocation: false,
    //         isActive: false,
    //         isApproved: false,
    //     },

    //     onSubmit: async (data) => {
    //         setloading(true);
    //         setloadingIcon("pi pi-spin pi-spinner");
    //         data["bankId"] = data?.bankId?.id;
    //         data["branchId"] = data?.branchId?.id;

    //         // if (editFlag__Store) {
    //         //     data["accountId"] = formData__Store?.accountId;
    //         //     const res = await handlePutRequest(data, "zbiz/nonFin/updateCompanyAccounts");
    //         //     if (res.status === 400) {
    //         //         res?.data.forEach((element) => {
    //         //             formik.setFieldError(element?.field, element?.message);
    //         //         });
    //         //     } else {
    //         //         dispatch(SetEditCompanyAccountFlagAction(false));
    //         //         dispatch(SetCompanyAccountFormDataToNullAction());
    //         //     }
    //         // } else {
    //         //     data["companyId"] = companyId;
    //         //     const res = await handlePostRequest(data, "zbiz/nonFin/saveCompanyAccounts");
    //         //     if (res.status === 400) {
    //         //         res?.data.forEach((element) => {
    //         //             formik.setFieldError(element?.field, element?.message);
    //         //         });
    //         //     } else formik.resetForm();
    //         // }
    //         setloading(false);
    //         setloadingIcon("pi pi-save");
    //         // getCompanyAccountDetail();
    //     },
    // });
    // const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    // const getFormErrorMessage = (name) => {
    //     return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    // };

    return (
        <></>
        //     <div className="card Card__Round">
        //         <div className="Form__Header">
        //             <h1> {type} bank branch </h1>
        //         </div>
        //         <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        //             <div className="p-fluid p-formgrid p-grid">
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="selectBankType" className={classNames({ "p-error": isFormFieldValid("selectBankType") }, "Label__Text")}>
        //                             Select Bank Type<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="selectBankType" placeholder="#xxxxxxxx" name="selectBankType" value={formik?.values?.selectBankType?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("selectBankType") }, "Input__Round")} />

        //                         {getFormErrorMessage("selectBankType")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="selectBank" className={classNames({ "p-error": isFormFieldValid("selectBank") }, "Label__Text")}>
        //                             Select Bank<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="selectBank" placeholder="#xxxxxxxx" name="selectBank" value={formik?.values?.selectBank?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("selectBank") }, "Input__Round")} />

        //                         {getFormErrorMessage("selectBank")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="branchCode" className={classNames({ "p-error": isFormFieldValid("branchCode") }, "Label__Text")}>
        //                             Branch Code<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="branchCode" placeholder="#xxxxxxxx" name="branchCode" value={formik?.values?.branchCode?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("branchCode") }, "Input__Round")} />

        //                         {getFormErrorMessage("branchCode")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="branchName" className={classNames({ "p-error": isFormFieldValid("branchName") }, "Label__Text")}>
        //                             Branch Name<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="branchName" placeholder="#xxxxxxxx" name="branchName" value={formik?.values?.branchName?.toString()?.trim()} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("branchName") }, "Input__Round")} />

        //                         {getFormErrorMessage("branchName")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="description" className={classNames({ "p-error": isFormFieldValid("description") }, "Label__Text")}>
        //                             Description<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputTextarea
        //                             placeholder="Add Description"
        //                             id="description"
        //                             name="description"
        //                             value={formik?.values?.description?.replace(/\s\s+/g, " ")}
        //                             rows={5}
        //                             cols={10}
        //                             onChange={formik.handleChange}
        //                             className={classNames({ "p-invalid": isFormFieldValid("description") }, "BankTextArea__Round")}
        //                         />
        //                         {getFormErrorMessage("description")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="branchAddress" className={classNames({ "p-error": isFormFieldValid("branchAddress") }, "Label__Text")}>
        //                             Branch Address<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputTextarea
        //                             placeholder="Add Description"
        //                             id="branchAddress"
        //                             name="branchAddress"
        //                             value={formik?.values?.branchAddress?.replace(/\s\s+/g, " ")}
        //                             rows={5}
        //                             cols={10}
        //                             onChange={formik.handleChange}
        //                             className={classNames({ "p-invalid": isFormFieldValid("branchAddress") }, "BankTextArea__Round")}
        //                         />
        //                         {getFormErrorMessage("branchAddress")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="branchContactNo" className={classNames({ "p-error": isFormFieldValid("branchContactNo") }, "Label__Text")}>
        //                             Branch Contact Number<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="branchContactNo" placeholder="#xxxxxxxx" name="branchContactNo" value={formik?.values?.branchContactNo?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("branchContactNo") }, "Input__Round")} />

        //                         {getFormErrorMessage("branchContactNo")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="selectCountry" className={classNames({ "p-error": isFormFieldValid("selectCountry") }, "Label__Text")}>
        //                             Select Country<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="selectCountry" placeholder="#xxxxxxxx" name="selectCountry" value={formik?.values?.selectCountry?.toString()?.trim()} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("selectCountry") }, "Input__Round")} />

        //                         {getFormErrorMessage("selectCountry")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="selectProvince" className={classNames({ "p-error": isFormFieldValid("selectProvince") }, "Label__Text")}>
        //                             Select Province<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="selectProvince" placeholder="#xxxxxxxx" name="selectProvince" value={formik?.values?.selectProvince?.toString()?.trim()} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("selectProvince") }, "Input__Round")} />

        //                         {getFormErrorMessage("selectProvince")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="selectCity" className={classNames({ "p-error": isFormFieldValid("selectCity") }, "Label__Text")}>
        //                             Select City<span className="Label__Required">*</span>
        //                         </label>
        //                         <InputText id="selectCity" placeholder="#xxxxxxxx" name="selectCity" value={formik?.values?.selectCity?.toString()?.trim()} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("selectCity") }, "Input__Round")} />

        //                         {getFormErrorMessage("selectCity")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="isActive" className={classNames({ "p-error": isFormFieldValid("isActive") }, "Label__Text")}>
        //                             Is Active
        //                         </label>
        //                         <div className="field-checkbox">
        //                             <Checkbox inputId="isActive" name="isActive" value={formik.values.isActive} checked={formik.values.isActive} onChange={formik.handleChange} />
        //                         </div>
        //                         {getFormErrorMessage("isActive")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="isPrintingLocation" className={classNames({ "p-error": isFormFieldValid("isPrintingLocation") }, "Label__Text")}>
        //                             Is Printing Location
        //                         </label>
        //                         <div className="field-checkbox">
        //                             <Checkbox inputId="isPrintingLocation" name="isPrintingLocation" value={formik.values.isPrintingLocation} checked={formik.values.isPrintingLocation} onChange={formik.handleChange} />
        //                         </div>
        //                         {getFormErrorMessage("isPrintingLocation")}
        //                     </div>
        //                 </div>
        //                 <div className="p-field p-col-12 p-md-4">
        //                     <div className="p-field">
        //                         <label htmlFor="isApproved" className={classNames({ "p-error": isFormFieldValid("isApproved") }, "Label__Text")}>
        //                             Is Approved
        //                         </label>
        //                         <div className="field-checkbox">
        //                             <Checkbox inputId="isApproved" name="isApproved" value={formik.values.isApproved} checked={formik.values.isApproved} onChange={formik.handleChange} />
        //                         </div>
        //                         {getFormErrorMessage("isApproved")}
        //                     </div>
        //                 </div>
        //             </div>
        //             {type === "Approve" || type === "Edit" ? (
        //                 <div>
        //                     <div className="Form__Header">
        //                         <h1> Logs </h1>
        //                     </div>
        //                     <div className="Logs__Wrapper" style={{ color: "black !important" }}>
        //                         <h6> 22 Apr 2022 1:20 PM Updated By I-8 Branch Manager </h6>
        //                         <h6> 21 Apr 2022 1:20 PM Updated By F-8 Branch Manager </h6>
        //                     </div>
        //                 </div>
        //             ) : (
        //                 ""
        //             )}

        //             <div className="Down__Btn">
        //                 <Button label="Cancel" onClick={(e) => handleCancel(e)} className="Btn__Transparent" />
        //                 <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={type} className="Btn__Dark" />
        //             </div>
        //         </form>
        //     </div>
    );
}

export default AddEditApproveBankBranchManagement;
